export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">投稿、合作、问题反馈，欢迎随时与我们取得联系</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
                <p className="text-xs md:text-sm text-foreground-500">comic@51mh.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服咨询</h3>
                <p className="text-xs md:text-sm text-foreground-500">service@51mh.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-group-line text-secondary-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                <p className="text-xs md:text-sm text-foreground-500">biz@51mh.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}